import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { getCleanStoryblokLink } from "@wojo/storyblok";
import { Button, Text } from "@wojo/ui";
import React, { useId } from "react";
import { TourPageSpecialDeparture } from "../../_client/context";
import { LuCalendarHeart } from "react-icons/lu";
import styles from "./SpecialDeparturesBanner.module.scss";

export type SpecialDeparturesBannerProps = {
    backgroundColor?: string;
    specialDepartures?: TourPageSpecialDeparture[];
};

export const SpecialDeparturesBanner: React.FC<
    SpecialDeparturesBannerProps
> = ({ backgroundColor, specialDepartures = [] }) => {
    const titleId = useId();
    const { productPage } = useI18n("productPage");

    if (specialDepartures.length === 0) {
        return null;
    }

    return (
        <section
            aria-labelledby={titleId}
            className={styles["special-departures"]}
            style={{
                backgroundColor: backgroundColor,
            }}
        >
            <div className={styles["special-departures-content"]}>
                <LuCalendarHeart aria-hidden size={20} strokeWidth={1.5} />
                <Text.Detail variant="2" id={titleId}>
                    {productPage.overview.specialDepartures.heading.l()}
                </Text.Detail>
            </div>
            <div className={styles["special-departures-links"]}>
                {specialDepartures.map((departure, index) => {
                    const { href, isExternal } = getCleanStoryblokLink(
                        departure.link,
                    );
                    return (
                        <Button
                            tag="a"
                            href={href}
                            target={isExternal ? "_blank" : undefined}
                            variant="quiet"
                            key={`special-departure_${titleId}_${index}`}
                            onClick={() => {
                                gtmSendEvent({
                                    event: "track",
                                    ga4Tracking: {
                                        ga4_action: "CLICKED",
                                        ga4_object: "SPECIAL_DEPARTURES",
                                        marketingBannerId: "special departures",
                                        clickText: departure.text,
                                        clickUrl: departure.link.cached_url,
                                    },
                                });
                            }}
                        >
                            {departure.text}
                        </Button>
                    );
                })}
            </div>
        </section>
    );
};
